import LazyLoad from "vanilla-lazyload";
import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollSmoother from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import zenScroll from "zenscroll";
import Cookies from "js-cookie";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

/* SETUP VARS */
let bw = document.body.scrollWidth;
let bh = window.innerHeight;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const cursor = document.getElementById("cursor");
const menuBtn = document.querySelector(".menuBtn");
const searchBtns = document.querySelectorAll(".searchTrigger");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");
const searchOverlay = document.getElementById("searchOverlay");
const searchForm = document.getElementById("searchform");
const searchIcon = searchForm.querySelector(".icon_search");
const searchClear = searchForm.querySelector(".icon_close");
const searchInput = searchForm.querySelector("input#keywords");
const searchDisplay = searchOverlay.querySelector(".display");
const searchResults = searchOverlay.querySelector(".results");

window.addEventListener("load", function (event) {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  ScrollSmoother.create({
    smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });

  let flkty;

  /* INTRO LOADING SEQUENCE */

  window.scroll(0, 0);

  let introEl = document.getElementById("intro");
  if (typeof introEl != "undefined" && introEl != null) {
    let introHeadline = introEl.querySelector("h1");
    let splitHeadline = new SplitText(introHeadline, { type: "lines" });
    let lines = splitHeadline.lines;

    setTimeout(function () {
      introEl.classList.add("on");

      gsap.from(lines, {
        duration: 1.2,
        y: 50,
        opacity: 0,
        stagger: 0.15,
        ease: "power3.out",
      });
    }, 250);

    if (innerWidth <= 767) {
      // gsap transform the header
      gsap.to(document.querySelector("header"), {
        y: 0,
        duration: 0.5,
        ease: "linear",
      });
    }
    setTimeout(function () {
      body.classList.remove("loading");
      flkty.playPlayer(3500);
      Cookies.set("sawintro", "yes", { expires: 7 });
    }, 3000);
  }

  /* ON PAGE LOAD, CHECK FOR WINDOW SIZE AND UPDATE WORK NAV LINKS TO DEFAULT TO GRID */
  if (window.innerWidth < 1024) {
    let workLinks = document.querySelectorAll("header nav a.work");
    workLinks.forEach((workLink) => {
      let newURL = workLink.getAttribute("data-mobile-url");
      workLink.setAttribute("href", newURL);
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function inviewInit() {
    //initialize lazyload - sitewide for image loading
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload for alternating grid
    const lazyLoadGrid = new LazyLoad({
      elements_selector: ".alternating .cell",
      callback_enter: loadGridCell,
      threshold: -50,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  inviewInit();

  function loadGridCell(el) {
    el.classList.add("ready");
  }

  function unloadGridCell(el) {
    el.classList.remove("ready");
  }

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playVideo(el) {
    let videoStr = el.getAttribute("data-video");
    let vidhold = el.querySelector(".vidhold");
    vidhold.innerHTML = videoStr;
    let vidEl = vidhold.querySelector("video");
    if (typeof vidEl != "undefined" && vidEl != null) {
      if (vidEl.classList.contains("sizeload")) {
        sizeloadVideo(vidEl);
      } else {
        vidEl.play();
      }
    }
    el.classList.add("playing");
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      if (videoEl.classList.contains("sizeload")) {
        sizeloadVideo(videoEl);
      } else {
        videoEl.play();
      }
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    //videoEl.pause();
    videoEl.parentNode.removeChild(videoEl);
    el.classList.remove("playing");
  }

  // initialize masonry
  const masongrid = document.getElementById("grid");

  if (typeof masongrid != "undefined" && masongrid != null) {
    //injecting bottom margin into masonry cell
    let gutterWidth = document.querySelector(".gutter-sizer").scrollWidth;
    let cells = masongrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masongrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  }

  //initialize flickity for slideshows

  let slideshowEls = document.querySelectorAll(".slideshow");
  slideshowEls.forEach((slideshowEl) => {
    let autoPlay = 3500;
    if (body.classList.contains("loading")) {
      autoPlay = false;
    }

    flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      autoPlay: autoPlay,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      cellSelector: ".cell",
      prevNextButtons: false,
      accessibility: true,
      pageDots: true,
      on: {
        ready: function () {
          let activeSlide = slideshowEl.querySelector(".is-selected");
          if (activeSlide.classList.contains("autovideo")) {
            playAutoVideo(activeSlide);
          }

          if (!body.classList.contains("projectpage")) {
            slideshowEl.focus();
          }

          /*

          // need to get width of pager lines to adjust width of arrows
          let pagerW = document.querySelector(
            ".flickity-page-dots"
          ).clientWidth;
          let slideArrows = document.querySelector(".slideshow .arrows");
          if (typeof slideArrows != "undefined" && slideArrows != null) {
            document.querySelector(".slideshow .arrows").style.width =
              pagerW + 80 + "px";
          }

          let nextArrow = document.querySelector(".slideshow .arrows .next");
          if (typeof nextArrow != "undefined" && nextArrow != null) {
            nextArrow.addEventListener("click", function (e) {
              e.preventDefault();
              flkty.next();
              flkty.stopPlayer();
            });
          }

          let prevArrow = document.querySelector(
            ".slideshow .arrows .previous"
          );
          if (typeof prevArrow != "undefined" && prevArrow != null) {
            prevArrow.addEventListener("click", function (e) {
              e.preventDefault();
              flkty.previous();
              flkty.stopPlayer();
            });
          }

          */

          /*
          let slideDots = document.querySelectorAll('.slideshow li.dot');

          slideDots.forEach(dot => {
            dot.addEventListener('mouseover', () => {
              linkenter();
            });
            dot.addEventListener('mouseleave', () => {
              linkleave();
            });
          })
          */
        },
      },
    });

    // change event
    flkty.on("change", function (index) {
      let activeSlide = slideshowEl.querySelector(".is-selected");
      if (activeSlide.classList.contains("autovideo")) {
        playAutoVideo(activeSlide);
      }
      // pause anyauto play videos
      let slideVideos = document.querySelectorAll(".slideshow .cell.autovideo");
      for (let i = 0; i < slideVideos.length; ++i) {
        if (!slideVideos[i].classList.contains("is-selected")) {
          let slideVideo = slideVideos[i].querySelector("video");
          if (typeof slideVideo !== "undefined" && slideVideo !== null) {
            slideVideo.pause();
            slideVideo.currentTime = 0;
          }
        }
      }
    });
  });

  // Slideshow for homepage
  let homeSlideshow = document.querySelector("#home-slideshow");
  let infoEls = document.querySelectorAll(".info");
  function customCursorInit(slideshow) {
    // Custom cursor and rotate position
    let cursor = document.querySelector(".cursor");

    slideshow.addEventListener("mousemove", (e) => {
      slideshow.style.setProperty("--cursor-state", "none");
      let mouseX = e.pageX;
      let mouseY = e.pageY;
      slideshow.style.setProperty("--mouse-x", mouseX + "px");
      slideshow.style.setProperty("--mouse-y", mouseY + "px");
      if (e.pageX < window.innerWidth * 0.5 - 25) {
        slideshow.style.setProperty("--rotate", "-180deg");
      } else {
        slideshow.style.setProperty("--rotate", "0");
      }
      infoEls.forEach((infoEl) => {
        infoContent = infoEl.querySelector("*");
        if (infoContent.contains(e.target)) {
          slideshow.style.setProperty("--cursor-state", "pointer");
          cursor.style.display = "none";
        } else {
          cursor.style.display = "block";
          slideshow.style.setProperty("--cursor-state", "none");
        }
      });
    });
  }
  const handleSlideshowClick = (e) => {
    let infoEl = homeSlideshow.querySelector(".info");
    // Get Flickity instance from the element
    let flkty = Flickity.data(homeSlideshow);

    // stop the autoplay
    flkty.stopPlayer();

    // after 5 seconds start the autoplay again
    setTimeout(() => {
      flkty.playPlayer(3500);
    }, 5000);

    // based on screen location, go to next or previous slide
    if (e.target !== infoEl) {
      if (e.pageX < window.innerWidth * 0.5) {
        flkty.previous();
      } else {
        flkty.next();
      }
    }
  };

  // staggered grid animation
  let gridStaggeredCells = document.querySelectorAll(".grid.staggered .cell");
  gridStaggeredCells.forEach((gridStaggeredCell) => {
    gsap.from(gridStaggeredCell, {
      scrollTrigger: {
        trigger: gridStaggeredCell,
        start: "top 80%",
        markers: false,
      },
      duration: 1,
      y: 80,
      opacity: 0,
      stagger: 0.1,

      ease: "power3.out",
    });
  });

  // document.addEventListener("mousemove", handleMouseMove);

  if (typeof homeSlideshow != "undefined" && homeSlideshow != null) {
    if (innerWidth > 767) {
      customCursorInit(homeSlideshow);
      document.addEventListener("click", handleSlideshowClick);
    }
  }

  // iOS header
  const header = document.querySelector("header"),
    headerStyle = window.getComputedStyle(header);

  let lastPosition = 0;

  document.addEventListener("scroll", () => {
    const currentPosition = window.scrollY,
      diff = currentPosition - lastPosition,
      headerHeight = parseFloat(headerStyle.height);

    let newTop = parseFloat(headerStyle.top) - diff;
    if (diff < 0) {
      //newTop = Math.min(newTop, 0);
      header.classList.remove("hide");
    } else {
      //newTop = Math.max(newTop, 0 - headerHeight - 8);
      header.classList.add("hide");
    }

    //header.style.top = `${newTop}px`;
    lastPosition = currentPosition;
  });

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    let src = "https://imaginaryforces.com";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = src + "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = src + "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = src + "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = src + "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = src + "/images/pics/1920/" + img;
      } else {
        imgpath = src + "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    // check for cols child before performing wrap
    let colsCheck = el.querySelector(".col");
    if (colsCheck != "undefined" && colsCheck != null) {
      let elContainer = document.createElement("div");
      Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
        elContainer.appendChild(c);
      });
      elContainer.classList.add("cols");
      el.appendChild(elContainer);
    }
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function postAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("POST", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
    body.classList.add("overlayOn");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    body.classList.remove("overlayOn");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
    let ratioCells = document.getElementsByClassName("ratioSize");
    for (let i = 0; i < ratioCells.length; i++) {
      ratioSize(ratioCells[i]);
    }

    let slideshowEl = document.querySelector(".slideshow");
    /*
    if (typeof slideshowEl != "undefined" && slideshowEl != null) {
      // slideshow pager dots resize and arrows
      let pagerW = document.querySelector(".flickity-page-dots").clientWidth;
      document.querySelector(".slideshow .arrows").style.width =
        pagerW + 60 + "px";
    }
        */

    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  // Carousel for Images - as seen on homepage

  let scrollingCarouselEls = document.querySelectorAll(".scrolling_images");

  function scrollingCarouselInit() {
    scrollingCarouselEls.forEach((scrollingCarouselEl) => {
      let carouselParent = scrollingCarouselEl.closest(".scrolling_images");
      let tickerSpeed;
      let isPaused = false;
      let flktyImages;

      if (carouselParent.classList.contains("reverse")) {
        tickerSpeed = -0.7;
      } else {
        tickerSpeed = 0.7;
      }

      // slow down for smaller screens
      if (innerWidth < 1940) {
        if (carouselParent.classList.contains("reverse")) {
          tickerSpeed = -0.5;
        } else {
          tickerSpeed = 0.5;
        }
      }

      const update = () => {
        if (isPaused) return;
        if (flktyImages.slides) {
          flktyImages.x =
            (flktyImages.x + tickerSpeed) % flktyImages.slideableWidth;
          //flktyImages.x = flktyImages.x * -1;

          flktyImages.selectedIndex = flktyImages.dragEndRestingSelect();
          flktyImages.updateSelectedSlide();
          flktyImages.settle(flktyImages.x);
        }
        window.requestAnimationFrame(update);
      };

      const pause = () => {
        isPaused = true;
      };

      const play = () => {
        if (isPaused) {
          isPaused = false;
          window.requestAnimationFrame(update);
        }
      };

      function goLeft(speed) {
        tickerSpeed = speed;
      }

      function goRight(speed) {
        tickerSpeed = -speed;
      }

      flktyImages = new Flickity(scrollingCarouselEl, {
        // options
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        groupCells: 4,
        selectedAttraction: 0.015,
        friction: 0.25,
      });
      flktyImages.x = 0;

      carouselParent.addEventListener("mousemove", (e) => {
        const halfWidth = window.innerWidth * 0.5;
        const distanceFromCenter = Math.abs(e.clientX - halfWidth);
        const maxSpeed = 2; // Adjust this value as needed
        const speed = (distanceFromCenter / halfWidth) * maxSpeed;

        if (e.clientX < halfWidth) {
          goLeft(speed);
          // update();
        } else {
          goRight(speed);
          // update();
        }
      });

      carouselParent.addEventListener("mouseleave", () => {
        tickerSpeed = carouselParent.classList.contains("reverse") ? -0.7 : 0.7;
      });

      update();
    });
  }

  let imageCarouselEl = document.querySelector(".scrolling_images");
  if (typeof imageCarouselEl != "undefined" && imageCarouselEl != null) {
    scrollingCarouselInit();
  }

  // Carousel for logosoup (who we are page)

  // autoplay logo carousel

  function logoCarouselInit() {
    let carousel = logoCarouselEl.closest(".scrolling-logos");

    let tickerSpeed = -0.5;
    let isPaused = false;

    let flktyLogos;

    const update = () => {
      if (isPaused) return;
      if (flktyLogos.slides) {
        flktyLogos.x = (flktyLogos.x + tickerSpeed) % flktyLogos.slideableWidth;
        //flktyLogos.x = flktyLogos.x * -1;

        flktyLogos.selectedIndex = flktyLogos.dragEndRestingSelect();
        flktyLogos.updateSelectedSlide();
        flktyLogos.settle(flktyLogos.x);
      }

      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flktyLogos = new Flickity(logoCarouselEl, {
      // options
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      groupCells: 4,
      selectedAttraction: 0.015,
      friction: 0.25,
    });

    flktyLogos.x = 0;

    update();
  }

  function logoCarouselReverseInit() {
    let carouselReverse = document.querySelector(".scrolling-logos.reverse");

    let tickerSpeed = -0.5;
    let isPaused = false;

    let flktyLogosReverse;

    const update = () => {
      if (isPaused) return;
      if (flktyLogosReverse.slides) {
        flktyLogosReverse.x =
          (flktyLogosReverse.x - tickerSpeed) %
          flktyLogosReverse.slideableWidth;
        flktyLogosReverse.selectedIndex =
          flktyLogosReverse.dragEndRestingSelect();
        flktyLogosReverse.updateSelectedSlide();
        flktyLogosReverse.settle(flktyLogosReverse.x);
      }
      window.requestAnimationFrame(update);
    };
    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };
    flktyLogosReverse = new Flickity(carouselReverse, {
      // options
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      groupCells: 4,
      selectedAttraction: 0.015,
      friction: 0.25,
    });

    flktyLogosReverse.x = 0;
    update();
  }

  let logoCarouselEl = document.querySelector(".scrolling-logos");
  let logoCarouselReverseEl = document.querySelector(
    ".scrolling-logos.reverse"
  );
  if (typeof logoCarouselEl != "undefined" && logoCarouselEl != null) {
    logoCarouselInit();
  }
  if (
    typeof logoCarouselReverseEl != "undefined" &&
    logoCarouselReverseEl != null
  ) {
    logoCarouselReverseInit();
  }

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // 2023 addition of "more work" module to reveal AR Rows grids
  let moreEls = document.querySelectorAll(".modules .more");
  moreEls.forEach((moreEl) => {
    let moreTrigger = moreEl.querySelector(".trigger");
    moreTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      let revealH;
      if (moreEl.classList.contains("open")) {
        revealH = 0;
        moreEl.querySelector(".trigger .label").innerHTML = "SEE MORE";
        moreEl.classList.remove("open");
      } else {
        revealH = moreEl.querySelector(".ar-rows").clientHeight;
        moreEl.querySelector(".trigger .label").innerHTML = "CLOSE";
        moreEl.classList.add("open");
      }
      moreEl.querySelector(".reveal").style.height = revealH + "px";
    });
  });

  // scroll to top
  let scrollToTopEl = document.getElementById("scrollToTop");
  if (typeof scrollToTopEl != "undefined" && scrollToTopEl != null) {
    scrollToTopEl.addEventListener("click", function () {
      zenScroll.toY(0);
    });
  }

  // 2022 addition of work button layouts - button filter on grid page
  let buttonFilterTriggers = document.querySelectorAll(".buttonFilterTrigger");
  buttonFilterTriggers.forEach((buttonFilterTrigger) => {
    buttonFilterTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      let buttonFilter = buttonFilterTrigger.closest(".filter");
      let dropdown = buttonFilter.querySelector("ul");
      if (buttonFilter.classList.contains("open")) {
        buttonFilter.classList.remove("open");
        dropdown.style.height = 0;
      } else {
        let dropItems = dropdown.querySelectorAll("li");
        let dropdownH = dropItems.length * 35;
        buttonFilter.classList.add("open");
        dropdown.style.height = dropdownH + "px";
      }
    });
  });

  window.onpopstate = function (e) {
    let popUrl = document.location.pathname;
    window.location.href = popUrl;
  };

  // link with #slidein value triggers slide page transition
  let slideInEl = document.querySelector("a.slidein");
  if (typeof slideInEl != "undefined" && slideInEl != null) {
    let newMainEl = document.querySelector("main#next");
    let oldMainEl = document.querySelector("main#current");
    let newUrl = slideInEl.getAttribute("href");
    slideInEl.addEventListener("click", function (e) {
      e.preventDefault();
      // add a transition class to body
      body.classList.add("slidein");
      // after transition reset scroll position
      // need to change new MAIN element position to relative, update body class
      setTimeout(function () {
        window.scroll(0, 0);
        newMainEl.classList.add("set");
        oldMainEl.classList.add("hidden");
        body.classList.remove("slidein");
      }, 1100);
      // update URL
      history.pushState({ url: newUrl }, "New URL: " + newUrl, newUrl);
    });
  }

  // goal component button click
  let goalBtns = document.querySelectorAll(".goals a.btn");
  goalBtns.forEach((goalBtn) => {
    goalBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let cell = goalBtn.closest(".cell");
      let secondary = cell.querySelector(".secondary");
      secondary.classList.add("show");
      if (innerWidth <= 1023) {
        let currentY = zenScroll.getY();
        zenScroll.toY(currentY + 300);
      }
    });
  });

  // track all a tags with class of bizdev to create custom ga event for email click
  let bizdevLinks = document.querySelectorAll("a.bizdev");
  bizdevLinks.forEach((bizdevLink) => {
    bizdevLink.addEventListener("click", function (e) {
      e.preventDefault();
      let href = bizdevLink.getAttribute("href");
      let gaEvent = "bizdev_email";
      // send the custom event to Google
      dataLayer.push({ event: gaEvent });
      gtag("event", gaEvent);
      window.location.href = href;
    });
  });

  // overlay text editor links - trigger a.overlay
  let overlayLinks = document.querySelectorAll("a.overlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let href = overlayLink.getAttribute("href");
      let page = "/getBusinessForm.php";
      let successPage = "/thank-you-business";
      let gaEvent = "business_overlay";
      let gaSuccess = "business_form_submit";
      if (href.indexOf("career") >= 0) {
        page = "/getCareerForm.php";
        successPage = "/thank-you-careers";
        gaEvent = "career_overlay";
        gaSuccess = "career_form_submit";
      }
      // send the custom event to Google
      dataLayer.push({ event: gaEvent });
      gtag("event", gaEvent);
      getAjax(page, function (data) {
        // load data into overlay
        overlayInner.innerHTML = data;
        cursorInit();
        openOverlay();

        // contact form submit
        let contactForm = overlayInner.querySelector(".contact-form");
        if (typeof contactForm != "undefined" && contactForm != null) {
          let successEl = document.getElementById("contactSuccess");
          let contactBtn = document.getElementById("contactBtn");
          contactForm.addEventListener("submit", function (e) {
            e.preventDefault();

            // disable button state
            contactBtn.classList.add("disabled");
            contactBtn.querySelector("span").innerHTML = "Sending...";

            var xhr = new XMLHttpRequest();
            var data = new FormData(contactForm);

            xhr.onload = function () {
              let response = this.responseText;
              if (response === "success") {
                //successEl.classList.add("on");
                //contactForm.classList.add("off");
                // send the custom event to Google
                gtag("event", gaSuccess);
                dataLayer.push({ event: gaSuccess });
                // redirect to business thank you page
                window.location.href = successPage;
              } else {
                alert(response);
              }
              contactBtn.classList.remove("disabled");
              contactBtn.querySelector("span").innerHTML = "Submit";
            };

            xhr.open("post", contactForm.action);
            xhr.send(data);
          });
        }
      });
    });
  });

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }

  // contact form submit
  let contactForm = document.getElementById("contactForm");
  if (typeof contactForm != "undefined" && contactForm != null) {
    let successEl = document.getElementById("contactSuccess");
    let contactBtn = document.getElementById("contactBtn");
    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // disable button state
      contactBtn.classList.add("disabled");

      var xhr = new XMLHttpRequest();
      var data = new FormData(contactForm);

      xhr.onload = function () {
        let response = this.responseText;
        if (response === "success") {
          successEl.classList.add("on");
          contactForm.classList.add("off");
        } else {
          alert(response);
        }
        contactBtn.classList.remove("disabled");
      };

      xhr.open("post", contactForm.action);
      xhr.send(data);
    });
  }

  // newsletter form submit
  let newsletterForm = document.getElementById("newsletterForm");
  if (typeof newsletterForm != "undefined" && newsletterForm != null) {
    let newsletterEmail = newsletterForm.querySelector("#newsletterEmail");
    let newsletterNotice = newsletterForm.querySelector(".notice");

    newsletterForm.addEventListener("submit", function (e) {
      e.preventDefault();
      let email = newsletterEmail.value;
      let emailCheck = ValidateEmail(email);
      if (emailCheck) {
        // ajax post to save to text file
        postAjax("/addNewsletter.php?email=" + email, function (data) {
          newsletterEmail.value = "";
          newsletterNotice.innerHTML = "Welcome!";
        });
      } else {
        newsletterNotice.innerHTML = "Please enter a valid email";
      }
    });
  }

  // lightbox links
  let lbLinks = document.querySelectorAll("a.lightbox");
  lbLinks.forEach((lbLink) => {
    lbLink.addEventListener("click", function (e) {
      e.preventDefault();
      let cell = this.closest(".cell");
      let itemID = this.getAttribute("data-id");
      getAjax("/getItem.php?id=" + itemID, function (data) {
        // load data into overlay
        overlayInner.innerHTML = data;

        // check for sizeload videos
        let lbVideo = overlayInner.querySelector("video");
        if (typeof lbVideo != "undefined" && lbVideo != null) {
          if (lbVideo.classList.contains("sizeload")) {
            sizeloadVideo(lbVideo);
          }
        }

        overlay.classList.add("on");
        body.classList.add("overlayOn");
        cell.classList.add("active");
        setTimeout(function () {
          overlayInner.querySelector(".wrap").classList.add("ready");
        }, 500);
      });
    });
  });

  // search form submit & results

  function getSearchResults(keyword) {
    body.classList.add("searchResults");
    getAjax("/getSearchResults.php?keywords=" + keyword, function (data) {
      // load data into overlay
      searchInput.blur();
      searchResults.innerHTML = data;
      let ratioCells = document.getElementsByClassName("ratioSize");
      for (let i = 0; i < ratioCells.length; i++) {
        ratioSize(ratioCells[i]);
      }
      inviewInit();
      hoverVideoInit();
      cursorInit();
      setTimeout(function () {
        searchDisplay.innerHTML = "";
      }, 500);
    });
  }

  searchClear.addEventListener("click", function (e) {
    e.preventDefault();
    body.classList.remove("searchResults");
    searchInput.value = "";
    searchResults.innerHTML = "";
    searchDisplay.innerHTML = "";
  });

  searchIcon.addEventListener("click", function (e) {
    e.preventDefault();
    let keywords = searchInput.value;
    getSearchResults(keywords);
  });

  searchForm.addEventListener("submit", function (e) {
    e.preventDefault();
    let keywords = searchInput.value;
    getSearchResults(keywords);
  });

  // PREDICTIVE SEARCH

  searchInput.addEventListener("keyup", function (e) {
    e.preventDefault();
    let keywords = searchInput.value;
    getAjax("/getSearchTitles.php?keywords=" + keywords, function (data) {
      searchDisplay.innerHTML = data;
      cursorInit();
    });
  });

  // custom hover on alternating grid media el to trigger text on state
  let altGridCells = document.querySelectorAll(".alternating .cell .media");
  altGridCells.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      let cell = item.parentNode;
      let readmore = cell.querySelector(".info .readmore");
      readmore.classList.add("active");
    });
  });
  altGridCells.forEach((item) => {
    item.addEventListener("mouseleave", function () {
      let cell = item.parentNode;
      let readmore = cell.querySelector(".info .readmore");
      readmore.classList.remove("active");
    });
  });

  //custom cursor

  function cursorInit() {
    let aLinks = document.querySelectorAll("a");

    if (bw > 767) {
      let adjX, adjY;

      function mousemove(e) {
        location.x = e.clientX;
        location.y = e.clientY;

        cursor.style.opacity = 1;

        window.requestAnimationFrame(function () {
          positionCursor(location, cursor);
        });
      }

      function mouseleave() {
        cursor.style.opacity = 0;
      }

      function linkenter() {
        cursor.classList.add("hover");
      }

      function linkleave() {
        cursor.classList.remove("hover");
      }

      function positionCursor(loc, element) {
        // need to update the offsets based on state of cursor
        adjY = 15;
        adjX = 25;
        element.style.top = loc.y - adjY + "px";
        element.style.left = loc.x - adjX + "px";
      }

      // handle default cursor on window move
      window.addEventListener("mousemove", mousemove);
      body.addEventListener("mouseleave", mouseleave);

      // handle custom cursor over links
      aLinks.forEach((item) => {
        item.addEventListener("mouseover", () => {
          linkenter();
        });
        item.addEventListener("mouseleave", () => {
          linkleave();
        });
      });

      let hoverMeEls = document.querySelectorAll(".hoverme");
      hoverMeEls.forEach((item) => {
        item.addEventListener("mouseover", () => {
          linkenter();
        });
        item.addEventListener("mouseleave", () => {
          linkleave();
        });
      });
    }
  }

  cursorInit();

  // ROSTER HOVER

  let rosterElCheck = document.querySelector(".roster");

  if (typeof rosterElCheck != "undefined" && rosterElCheck != null) {
    if (innerWidth > 767) {
      let roster = document.querySelector(".roster");
      let rosterInner = document.querySelector(".roster .inner");
      let rosterRect = rosterInner.getBoundingClientRect();
      if (typeof rosterInner != "undefined" && rosterInner != null) {
        let floatingDiv = document.querySelector(".wrapper");
        let floatingDivImg = floatingDiv.querySelector("img");
        let cells = document.querySelectorAll(".roster .cell");
        let prevCell;
        let img1;
        let img2;
        let images;
        let rosterTL = gsap.timeline();
        rosterTL.set(floatingDiv, { scale: 0.9 });
        cells.forEach((cell) => {
          const title = cell.querySelector(".title");
          title.addEventListener("mouseenter", async function () {
            let selectedImg = cell.querySelector("img");
            let selectedImgCopy = selectedImg.cloneNode(true);
            images = floatingDiv.querySelectorAll("img");
            let img1;
            let img2;
            if (images.length < 1) {
              floatingDiv.appendChild(selectedImgCopy);
              img1 = floatingDiv.querySelector("img:first-child");
              rosterTL.clear();
              rosterTL
                .to(floatingDiv, {
                  scale: 1,
                  opacity: 1,
                  duration: 0.3,
                })
                .to(img1, {
                  opacity: 1,
                  duration: 0.3,
                });
              prevCell = cell;
            } else {
              if (prevCell == cell) {
                return;
              }
              floatingDiv.appendChild(selectedImgCopy);
              images = floatingDiv.querySelectorAll("img");
              if (images.length > 2) {
                floatingDiv.removeChild(images[0]);
                images = floatingDiv.querySelectorAll("img");
              }

              img1 = images[0];
              img2 = images[1];

              rosterTL.clear();
              rosterTL

                .to(
                  floatingDiv,
                  {
                    opacity: 1,
                    duration: 0.3,
                  },
                  "<"
                )
                .to(img1, {
                  opacity: 0,
                  duration: 0.3,
                })
                .to(
                  img2,
                  {
                    opacity: 1,
                    duration: 0.3,
                  },
                  "<"
                );
            }
            prevCell = cell;
          });
        });

        rosterInner.addEventListener("mousemove", function (e) {
          let x = innerWidth * 0.03;
          let y = e.pageY - 60;

          /*
        if (y > rosterRect.y + rosterRect.height - 500) {
          y = e.pageY - 500;
        }
        */

          floatingDiv.style.setProperty("--x", x + "px");
          floatingDiv.style.setProperty("--y", y + "px");
          floatingDiv.style.setProperty("--speed", 0);
        });
        roster.addEventListener("mouseleave", function () {
          rosterTL.clear();
          rosterTL.to(floatingDiv, {
            scale: 0.9,
            opacity: 0,
            duration: 0.1,
            onComplete: function () {
              floatingDiv.innerHTML = "";
            },
          });
        });
        roster.addEventListener("mouseenter", function () {
          rosterTL.clear();
          rosterTL.to(floatingDiv, {
            scale: 0.9,
            opacity: 1,
            duration: 0.3,
          });
        });
      }
    }
  }

  // work "slivers" parallax

  let sliverCells = document.querySelectorAll(".croppedgrid .cell");
  let sliverCellsLength = sliverCells.length;

  for (let i = 0; i < sliverCellsLength; ++i) {
    let cell = sliverCells[i];
    let img = cell.querySelector("img.photo");

    if (!cell.classList.contains("text_only")) {
      gsap.to(img, {
        scrollTrigger: {
          trigger: cell, //this is the element that will trigger the animation
          start: "top bottom", //this string defines the trigger and scroller start
          end: "bottom top", //this string defines the trigger and scroller end
          scrub: 1, //this tells GSAP to link animation progress to scroll progress
          markers: false,
        },
        objectPosition: "50% 65%",
      });
    }
  }

  const bgHolder = document.getElementById("bgHolder");

  // list view item hover - full page image
  let listTriggers = document.querySelectorAll(".hover-image");
  let listTriggersLength = listTriggers.length;

  if (bw > 767) {
    for (let i = 0; i < listTriggersLength; ++i) {
      let listTrigger = listTriggers[i];
      listTrigger.addEventListener("mouseenter", function () {
        body.classList.add("light_theme");
        let img = this.getAttribute("data-img");
        let video = this.getAttribute("data-video");
        if (video !== "") {
          bgHolder.querySelector(".vidhold").innerHTML = video;
          // check for sizeload class on bg video
          let bgVideo = bgHolder.querySelector("video");
          if (bgVideo.classList.contains("sizeload")) {
            sizeloadVideo(bgVideo, "no");
          } else {
            bgVideo.play();
          }
        } else {
          bgHolder.querySelector("img").setAttribute("src", img);
        }
        bgHolder.classList.add("show");
      });
      listTrigger.addEventListener("mouseleave", function () {
        body.classList.remove("light_theme");
        bgHolder.querySelector(".vidhold").innerHTML = "";
        bgHolder
          .querySelector("img")
          .setAttribute(
            "src",
            "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          );
        bgHolder.classList.remove("show");
      });
    }
  }

  let playTriggers = document.querySelectorAll(".play-trigger");
  let playTriggersLength = playTriggers.length;
  for (let i = 0; i < playTriggersLength; ++i) {
    playTriggers[i].addEventListener("click", function (e) {
      e.preventDefault();
      let cell = this.closest(".cell");
      playVideo(cell);
    });
  }

  let inlineTriggers = document.querySelectorAll(".inline_video");
  let inlineTriggersLength = inlineTriggers.length;
  for (let i = 0; i < inlineTriggersLength; ++i) {
    inlineTriggers[i].addEventListener("click", function (e) {
      e.preventDefault();
      let cell = this.closest(".cell");
      if (!cell.classList.contains("playing")) {
        playVideo(cell);
      }
    });
  }

  function hoverVideoInit() {
    let hoverVideoCells = document.querySelectorAll(".cell.hovervideo");
    let hoverVideoCellsLength = hoverVideoCells.length;
    for (let i = 0; i < hoverVideoCellsLength; ++i) {
      hoverVideoCells[i].addEventListener("mouseenter", function (e) {
        e.preventDefault();
        let cell = this;
        playAutoVideo(cell);
      });
      hoverVideoCells[i].addEventListener("mouseleave", function (e) {
        e.preventDefault();
        let cell = this;
        pauseAutoVideo(cell);
      });
    }
  }

  hoverVideoInit();

  // search icons

  searchBtns.forEach((searchBtn) => {
    searchBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        if (body.classList.contains("searchOn")) {
          body.classList.remove("searchOn", "searchResults");
          searchInput.value = "";
          searchResults.innerHTML = "";
        } else {
          // get the current page URL
          let currentURL = window.location.href;
          body.classList.add("searchOn");
          gtag("event", "search_opened", {
            page: currentURL,
          });
        }
      },
      true
    );
  });

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault(), document.body.classList.toggle("menuOn");
    },
    true
  );

  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );

  // HEADER change on scroll up/down
  // var scrollPosition = window.pageYOffset;
  // //let element = document.querySelector(".main-header");

  // window.addEventListener(
  //   "scroll",
  //   function () {
  //     scrollPosition = window.pageYOffset;

  //     // any scroll on homepage should remove loading class from body
  //     if (body.classList.contains("homepage")) {
  //       if (scrollPosition > 0) {
  //         body.classList.remove("loading");
  //       }
  //     }

  //     /*

  //     if (scrollPosition > 100) {
  //       body.classList.add("scrolled");
  //     } else {
  //       body.classList.remove("scrolled"), body.classList.remove("menuOn");
  //     }

  //     */
  //     //lastScrollTop = st;
  //   },
  //   false
  // );

  // DRAWER CLICKS =================

  let drawerBtns = document.querySelectorAll(".job_title_wrap");
  for (let i = 0; i < drawerBtns.length; i++) {
    let drawerBtn = drawerBtns[i];
    drawerBtn.addEventListener("click", drawerToggle);
  }

  function drawerToggle() {
    let job = this.closest(".job"),
      reveal = job.querySelector(".reveal"),
      revealH = 0,
      wrapper = job.querySelector(".wrapper"),
      closeBtn = job.querySelector(".drawer-closer");

    if (reveal.classList.contains("open")) {
      revealH = 0;
    } else {
      revealH = wrapper.offsetHeight;
    }
    reveal.style.height = revealH + "px";
    reveal.classList.toggle("open");
    job.classList.toggle("open");
    closeBtn.classList.toggle("visible");
  }
});
